import ElementUpdater from './elementUpdater'
import Selector from './selector'

const getEditControlsAlignment = (logoAlignment) => {
  if (logoAlignment === 'left') {
    return 'right'
  }
  return 'left'
}

const updateNavigation = (styles) => {
  const { logoAlignment } = styles

  const navigationContainer = document.querySelectorAll(
    '.presentation_control_container.presentation_navigation'
  )

  navigationContainer.forEach((element) => {
    element.style['background-color'] = '#000'
    element.style['border-color'] = '#808080'
    element.style.opacity = '0.5'
    element.style.float = getEditControlsAlignment(logoAlignment)
  })

  const editContainer = document.querySelectorAll(
    '.presentation_slideshow_edit'
  )

  editContainer.forEach((element) => {
    element.style.display = 'none'
  })
}

const updateSharedStyles = (styles, targetElement = document) => {
  const {
    backgroundColor,
    backgroundImage,
    backgroundImageOpacity,
    titleFontColor,
    titleFontFamily,
    titleFontWeight,
    bodyFontColor,
    bodyFontFamily,
    bodyFontWeight,
    cardBoxShadow,
  } = styles

  const backgroundImageURL = `url(${backgroundImage})`
  const backgroundImageWrapperSelector =
    '.presentation_slide .slide_background_image_wrapper'
  const slideTitleSelector = '.presentation_slide .slide_title'
  const slideDescriptionSelector = '.presentation_slide .slide_description'
  const presentationSlideSelector = '.presentation_slide'
  const contentCardSelector = '.presentation_slide .contentCard'
  const slideTransitionBackground =
    '.presentation_viewer_show .presentation_slides'
  const slideNumber =
    '.presentation_viewer_show .presentation_control_container.presentation_slideshow_edit'

  const selectors = [
    new Selector({
      selection: backgroundImageWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: slideTitleSelector,
      required: true,
    }),
    new Selector({
      selection: slideDescriptionSelector,
      required: true,
    }),
    new Selector({
      selection: presentationSlideSelector,
      required: true,
    }),
    new Selector({
      selection: contentCardSelector,
      required: false,
    }),
    new Selector({
      selection: slideTransitionBackground,
      required: false,
    }),
    new Selector({
      selection: slideNumber,
      required: false,
    }),
  ]

  const updateStyles = () => {
    updateNavigation(styles)

    targetElement
      .querySelectorAll(slideTransitionBackground)
      .forEach((element) => {
        element.style['background-color'] = backgroundColor
      })

    targetElement
      .querySelectorAll(presentationSlideSelector)
      .forEach((element) => {
        element.style['background-color'] = backgroundColor
      })

    targetElement
      .querySelectorAll(backgroundImageWrapperSelector)
      .forEach((element) => {
        element.style['background-image'] = backgroundImageURL
        element.style['background-repeat'] = 'no-repeat'
        element.style['background-size'] = 'cover'
        element.style.opacity = backgroundImageOpacity
        element.style.position = 'absolute'
        element.style.left = '0'
        element.style.right = '0'
        element.style.bottom = '0'
      })

    targetElement.querySelectorAll(slideTitleSelector).forEach((element) => {
      element.style.color = titleFontColor
      element.style['font-family'] = titleFontFamily
      element.style['font-weight'] = titleFontWeight
      element.style['line-height'] = '1.2em'
    })

    targetElement
      .querySelectorAll(slideDescriptionSelector)
      .forEach((element) => {
        element.style.color = bodyFontColor
        element.style['font-family'] = bodyFontFamily
        element.style['font-weight'] = bodyFontWeight
        element.style['line-height'] = '1.3em'
        element.style['margin-top'] = '16px'
      })

    targetElement.querySelectorAll(contentCardSelector).forEach((element) => {
      element.style['box-shadow'] = cardBoxShadow
    })

    targetElement.querySelectorAll(slideNumber).forEach((element) => {
      element.style.display = 'none'
    })
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateSharedStyles
